import {
  SET_COUPON_MODAL_IS_VISIBLE,
  COUPON_POST_SUCCESS,
  SET_IS_REQUESTING,
  ADD_NEW_PROMO_CODE,
  SET_INVALID_PROMO_CODE,
  SET_PROMO_CODE,
} from './couponsTypes';
import api from '../../api';
import { createAlert } from '../../modules/Alert/alertActions';

export function setCouponsModalIsVisible(isCouponModalVisible, promoType) {
  return {
    type: SET_COUPON_MODAL_IS_VISIBLE,
    isCouponModalVisible: isCouponModalVisible,
    promoType: promoType,
  };
}

export function applyCouponCode(couponCode) {
  return function(dispatch) {
    dispatch({ type: SET_IS_REQUESTING, boolean: true });
    api
      .post('/coupons/apply', { coupon_code: couponCode })
      .then((response) => {
        dispatch({
          type: COUPON_POST_SUCCESS,
          couponType: response.data.data.type,
          couponValue: response.data.data.value,
        });
        dispatch(
          createAlert({
            type: 'sucess',
            message:
              response.data.data.type == 'money'
                ? `Successfully added $${response.data.data.value} to your account`
                : `Successfully added ${response.data.data.value} points to your account`,
          })
        );
      })
      .catch((error) => {
        dispatch({ type: SET_IS_REQUESTING, boolean: false });
        console.error(error);
      });
  };
}

export function validatePromoCode(promoCode) {
  return function(dispatch, getState) {
    const promoCodes = getState().couponsReducer.promoCodes;

    if (promoCodes.includes(promoCode)) {
      dispatch(createAlert({ type: 'sucess', message: 'Promo Code added' }));
      return;
    }

    const {
      interOrderType,
      interPickUpDetails,
      interDeliveryDetails,
      interDropOffDetails,
    } = getState().orderSettingReducer;

    const business_id =
      interOrderType === 'pickup'
        ? interPickUpDetails.id
        : interOrderType === 'delivery' && interDeliveryDetails.deliveryBusiness
        ? interDeliveryDetails.deliveryBusiness.id
        : interOrderType === 'drop-off'
        ? interDropOffDetails.id
        : null;

    const payload = {
      business_id,
      offer_code: promoCode,
      order_type: interOrderType,
    };

    api.post('/offer/validate_code', payload).then((response) => {
      if (response.data.data.is_valid) {
        dispatch(createAlert({ type: 'sucess', message: 'Promo Code added' }));
        dispatch({ type: ADD_NEW_PROMO_CODE, promoCode });
        dispatch(setCouponsModalIsVisible(false, ''));
      } else dispatch({ type: SET_INVALID_PROMO_CODE });
    });
  };
}

export function removePromoCode(promoCode) {
  return function(dispatch, getState) {
    const promoCodes = getState().couponsReducer.promoCodes;

    const newPromoCodeList = promoCodes.filter((promo) => promo !== promoCode);
    dispatch({ type: SET_PROMO_CODE, promoCodes: newPromoCodeList });
  };
}

export function resetPromoCodes() {
  return function(dispatch) {
    dispatch({ type: SET_PROMO_CODE, promoCodes: [] });
  };
}
